import Immutable from "seamless-immutable";

const initialState = Immutable({});

const SpacesReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default SpacesReducer;
